import React, { Component } from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import ScrollHandler from '@fiverr-private/scroll_handler';
import { monitor } from '../../store/actions';
import * as apps from '../../enums/apps';
import TabContent from '../TabContent';
import './style.scss';

class ScrollWrapper extends Component {
    constructor(props) {
        super(props);

        this.revealOlder = this.revealOlder.bind(this);
    }

    componentDidMount() {
        this.scrollHandler = new ScrollHandler(this.scrollWrapper, {
            bottomAction: this.revealOlder,
            threshold: 45,
            every: 60,
        });
    }

    revealOlder() {
        const { showMore, monitor, active } = this.props;

        showMore();
        monitor(active, 'show_more');
    }

    render() {
        const { shownCount, active, drawerType, className } = this.props;

        return (
            <div className={classNames('scroll-wrapper', className)} ref={(ref) => (this.scrollWrapper = ref)}>
                <TabContent shownCount={shownCount} name={active} drawerType={drawerType} />
            </div>
        );
    }
}

ScrollWrapper.propTypes = {
    active: propTypes.oneOf([apps.APP_NAME_INBOX, apps.APP_NAME_NOTIFICATIONS]),
    showMore: propTypes.func,
    className: propTypes.string,
    monitor: propTypes.func,
    shownCount: propTypes.number,
    drawerType: propTypes.string,
};

export default connect(null, { monitor })(ScrollWrapper);
